import type {
    EmvConfigurationEntityObject,
    EmvConfigurationQueryParams,
} from "src/app/features/EmvKernelProfile/subFeatures/EmvConfiguration/services/server/EmvConfigurationQueryTypes";
import type { EmvConfigurationEntity } from "src/app/features/EmvKernelProfile/subFeatures/EmvConfiguration/types/EmvConfigurationEntity";
import { getAssignedDataGroup } from "../../../../../../../core/router/auth";
import { ResourceName, ResourceVariant } from "../../../../../../../core/router/config/ResourceName";
import { baseAuthApi } from "../../../../../../../core/service/baseApi";
import type { Dto } from "../../../../../../../core/types/be/Dto";
import { EmvConfigurationDtoToEntity } from "../mappers/EmvConfigurationDtoToEntity";
import { EmvConfigurationEntityToDto } from "../mappers/EmvConfigurationEntityToDto";

const EmvConfigurationApi = baseAuthApi.injectEndpoints({
    endpoints: (builder) => ({
        EmvConfigurationLoad: builder.query<EmvConfigurationEntity, EmvConfigurationQueryParams>({
            providesTags: [ResourceName.EMV_CONFIGURATIONS],
            query: (emvConfigurationQueryParams) => {
                const dataGroup = getAssignedDataGroup();
                return {
                    url: `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.EMV_KERNEL_PROFILES}/${ResourceVariant.APAC}/${emvConfigurationQueryParams.emvKernelProfileId}/${ResourceName.EMV_CONFIGURATIONS}/${emvConfigurationQueryParams.id}`,
                    method: "GET",
                };
            },
            transformResponse: (response: Dto, _) => {
                return EmvConfigurationDtoToEntity(response);
            },
        }),
        EmvConfigurationSave: builder.mutation<EmvConfigurationEntity, EmvConfigurationEntityObject>({
            query: (emvConfigurationEntityObject) => {
                const dataGroup = getAssignedDataGroup();

                const url = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.EMV_KERNEL_PROFILES}/${ResourceVariant.APAC}/${emvConfigurationEntityObject.emvConfigurationQuery.emvKernelProfileId}/${ResourceName.EMV_CONFIGURATIONS}`;
                const method = "POST";

                const body = EmvConfigurationEntityToDto(emvConfigurationEntityObject.emvConfigurationFormData);

                return {
                    url,
                    method,
                    body,
                };
            },
            invalidatesTags: [ResourceName.EMV_CONFIGURATIONS],
        }),
        EmvConfigurationUpdate: builder.mutation<EmvConfigurationEntity, EmvConfigurationEntityObject>({
            query: (emvConfigurationEntityObject) => {
                const dataGroup = getAssignedDataGroup();

                const url = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.EMV_KERNEL_PROFILES}/${ResourceVariant.APAC}/${emvConfigurationEntityObject.emvConfigurationQuery.emvKernelProfileId}/${ResourceName.EMV_CONFIGURATIONS}/${emvConfigurationEntityObject.emvConfigurationQuery.id}`;
                const method = "PUT";

                const body = EmvConfigurationEntityToDto(emvConfigurationEntityObject.emvConfigurationFormData);

                return {
                    url,
                    method,
                    body,
                };
            },
            invalidatesTags: [ResourceName.EMV_CONFIGURATIONS],
        }),
        EmvConfigurationDelete: builder.mutation<EmvConfigurationEntity, EmvConfigurationQueryParams>({
            query: (emvConfigurationQueryParams) => {
                const dataGroup = getAssignedDataGroup();
                return {
                    url: `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.EMV_KERNEL_PROFILES}/${ResourceVariant.APAC}/${emvConfigurationQueryParams.emvKernelProfileId}/${ResourceName.EMV_CONFIGURATIONS}/${emvConfigurationQueryParams.id}`,
                    method: "DELETE",
                };
            },
            invalidatesTags: [ResourceName.EMV_CONFIGURATIONS],
        }),
    }),
});

export const {
    useLazyEmvConfigurationLoadQuery,
    useEmvConfigurationSaveMutation,
    useEmvConfigurationUpdateMutation,
    useEmvConfigurationDeleteMutation,
} = EmvConfigurationApi;
